import { isOneOfTags } from 'anodum';
import getSupportedTagNames from './get-supported-tag-names';
import removeRelatedClassName from './remove-related-class-name';

const removeRelatedClassesFromElement = (element) => {
  if (!element) {
    return null;
  }

  const supportedTags = getSupportedTagNames();
  if (isOneOfTags(element, supportedTags)) {
    removeRelatedClassName(element);
  }

  element.querySelectorAll(supportedTags).forEach(removeRelatedClassName);

  if (element.classList.length === 0) {
    element.removeAttribute('class');
  }

  return element;
};

export default removeRelatedClassesFromElement;
